import Flags from './Flags';
import FontAwesome from './FontAwesome';
import SimpleLineIcons from './SimpleLineIcons';

export {
  Flags, FontAwesome, SimpleLineIcons
};



// WEBPACK FOOTER //
// ./src/views/framework/Icons/index.js